import {atom, useAtomValue, useSetAtom} from 'jotai/index';

import {AppCategory} from '@web-catalog/types';

export type CategoriesAtom = {
  appsCategories: Array<AppCategory>;
  gamesCategories: Array<AppCategory>;
};

export const categoriesAtom = atom<CategoriesAtom>({
  appsCategories: [],
  gamesCategories: [],
});

export const useCategoriesAtomValue = () => useAtomValue(categoriesAtom);

export const useSetCategoriesAtom = () => useSetAtom(categoriesAtom);
